import Vue from 'vue'
import VueRouter from 'vue-router'
import ShipMealRouter from '@/router/modules/ShipMeal'
import OtherSyncRouter from '@/router/modules/OtherSync'
import SpecialRouter from '@/router/modules/Special'
import SpecialKwaiRouter from '@/router/modules/SpecialKwai'
import YonghuiSyncRouter from '@/router/modules/YonghuiSync'
import SyncLinkRouter from '@/router/modules/SyncLink'
import syncPopRouter from '@/router/modules/syncPop'
import QuickSyncLinkRouter from '@/router/modules/QuickSyncLink'
import PhysicalRedeemCodeRouter from '@/router/modules/PhysicalRedeemCode'
import comboSyncRouter from '@/router/modules/comboSync'
import verifyV2 from '@/router/modules/verifyV2'
import baidu from '@/router/modules/baidu'
import citicSync from '@/router/modules/citicSync'
import fsl from '@/router/modules/fsl'
import rightActivityH5 from '@/router/modules/rightActivityH5'
import enterpriseCodeRouter from '@/router/modules/enterpriseCode'
Vue.use(VueRouter)
const router = new VueRouter({
  routes: [
    {
      path: '/',
      redirect: 'Coupon'
    },
    {
      path: '/upgrade',
      name: 'upgrade',
      meta: { title: '系统升级' },
      component: () => import('../views/upgrade.vue')
    },
    {
      path: '/Coupon',
      name: 'Coupon',
      meta: { title: '卡券商品兑换' },
      component: () => import('../views/Coupon.vue')
    },
    // 兑换页配置：卡券通用（query 保留 type=0、view=1 等，与原 Coupon 逻辑兼容）
    {
      path: '/customCoupon',
      name: 'CustomCoupon',
      meta: { title: '卡券兑换' },
      component: () => import('../views/CustomCoupon.vue')
    },
    {
      path: '/Recharge',
      name: 'Recharge',
      meta: { title: '商品直充' },
      component: () => import('../views/Recharge.vue')
    },
    // 兑换页配置：直充通用（query 保留 type=6、view=1 等，与原 Recharge 逻辑兼容）
    {
      path: '/customRecharge',
      name: 'CustomRecharge',
      meta: { title: '商品直充' },
      component: () => import('../views/CustomRecharge.vue')
    },
    {
      path: '/Coating',
      name: 'Coating',
      meta: { title: '涂层兑换码' },
      component: () => import('../views/Coating.vue')
    },
    {
      path: '/ECoating',
      name: 'ECoating',
      meta: { title: '电商涂层兑换码' },
      component: () => import('../views/ECoating')
    },
    {
      path: '/ECoating/detail',
      name: 'ECoatingDetail',
      meta: { title: '电商涂层兑换码券码详情' },
      component: () => import('../views/ECoating/orderDetail')
    },
    {
      path: '/error',
      name: 'Error',
      meta: { title: '404页' },
      component: () => import('../views/error.vue')
    },
    {
      path: '/SeriesCode',
      name: 'SeriesCode',
      meta: { title: '涂层串码' },
      component: () => import('../views/SeriesCode.vue')
    },
    // 特殊直充兑换码需求（（1）发放手机号必须与兑换手机号一致（2）同步兑换码（3）需要专属兑换链接，在其他兑换链接不可被兑换）
    {
      path: '/SpecialRecharge',
      name: 'SpecialRecharge',
      meta: { title: '通用定制兑换' },
      component: () => import('../views/SpecialRecharge')
    },
    // T1006188 特殊兑换码也做一个链接类型的兑换码
    {
      path: '/srl',
      name: 'srl',
      meta: { title: '通用定制兑换' },
      component: () => import('../views/srl')
    },
    {
      path: '/zfb/:code',
      name: 'alipay',
      meta: { title: '订单通知' },
      component: () => import('../views/alipay')
    },
    {
      path: '/wechat/:code',
      name: 'wechat',
      meta: { title: '易点权益' },
      component: () => import('../views/wechat')
    },
    {
      path: '/wechatDiscount',
      name: 'wechatDiscount',
      meta: { title: '微信立减金' },
      component: () => import('../views/wechatDiscount')
    },
    ...SyncLinkRouter,
    ...YonghuiSyncRouter,
    ...SpecialRouter,
    ...SpecialKwaiRouter,
    ...OtherSyncRouter,
    ...ShipMealRouter,
    ...QuickSyncLinkRouter,
    ...PhysicalRedeemCodeRouter,
    ...syncPopRouter,
    ...comboSyncRouter,
    ...verifyV2,
    ...baidu,
    ...citicSync,
    ...fsl,
    ...rightActivityH5,
    ...enterpriseCodeRouter
  ]
})

export default router
